import Link from 'next/link';
import { useRouter } from 'next/router';
import { forwardRef, useEffect, useMemo, useState } from 'react';
import { getUrlLocale, isUrlInternal } from '@/core/utils';

type RhLinkProps = React.ComponentProps<typeof Link> & {
  href: string;
  role?: string;
};

const RhLink = forwardRef<HTMLAnchorElement, RhLinkProps>((props, ref) => {
  const { href, role, children } = props;
  const router = useRouter();
  const locale = useMemo(() => getUrlLocale(router.asPath), [router.asPath]);
  const [localizedUrl, setLocalizedUrl] = useState(href || '#');

  useEffect(() => {
    if (localizedUrl === '#') return;
    if (isUrlInternal(href) && locale && locale !== 'en' && !href.startsWith(`/${locale}/`)) {
      setLocalizedUrl(`/${locale}${href.startsWith('/') ? '' : '/'}${href}`);
    }
  }, []);

  return (
    <Link
      {...props}
      href={localizedUrl}
      ref={ref}
      role={role}
    >
      {children}
    </Link>
  )
});

export default RhLink;